// A Next.js code-split chunk that failed to load — happens when a deploy rotated the hashed
// chunk filenames while a browser still held a page from the previous build (a long-lived
// tab, or stale cached HTML). The clean recovery is a full reload, which fetches fresh HTML
// referencing the current chunks. Used by the error boundaries (error.tsx / global-error.tsx).

export function isChunkLoadError(error: { name?: string; message?: string } | null | undefined): boolean {
  if (!error) return false
  return error.name === 'ChunkLoadError' || /loading chunk|failed to load chunk|importing a module script failed/i.test(error.message ?? '')
}

// Reload once to recover from a stale chunk. Guarded by a sessionStorage timestamp so a chunk
// that is GENUINELY gone (not just stale) can't trigger an infinite reload loop — after one
// attempt in a 10s window the caller falls back to showing the error UI. A short delay lets
// the error log flush before navigation. Returns true if a reload was scheduled.
export function reloadOnceForChunkError(): boolean {
  if (typeof window === 'undefined') return false
  const KEY = 'ppl_chunk_reload_at'
  try {
    const last = Number(sessionStorage.getItem(KEY) || '0')
    if (Date.now() - last < 10_000) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    // sessionStorage unavailable (private mode quirks) — still attempt a single reload.
  }
  setTimeout(() => window.location.reload(), 150)
  return true
}
